import { TOKEN_PATH } from "src/config";

import {
  AwsGateCallbacks,
  AwsGateRequest,
  AxiosGateCallbacks,
  AxiosGateRequest,
  GetCommunicationToken,
  GetIdToken,
  ServiceType,
} from "src/types";
import { useAxios } from "src/networking/axios/axios.hook";
import { useAws } from "src/networking/aws/aws.hook";

export const useGetIdToken = <
  T extends GetIdToken["request"],
  D extends GetIdToken["response"],
>() => {
  const hook = useAxios<T, D>("getIdToken");

  return {
    ...hook,
    crossGate: (
      request: AxiosGateRequest<T>,
      callbacks: AxiosGateCallbacks<D>,
    ) => {
      return hook.crossGate(
        {
          method: "get",
          baseURL: TOKEN_PATH,
          ...request,
        },
        callbacks,
      );
    },
  };
};

export const GET_TOKEN_HEADER = {
  "Content-Type": "application/x-amz-json-1.1",
  accept: "application/json",
  "Accept-Language": "IT",
};

export const useGetCommunicationToken = <
  T extends GetCommunicationToken["request"],
  D extends GetCommunicationToken["response"],
>() => {
  const hook = useAws<T, D>("getCommunicationToken", ServiceType.COMMUNICATION);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const code = request.uriParams.code;

      return hook.crossGate(
        {
          method: "get",
          path: `/token/${code}`,
          ...request,
        },
        callbacks,
      );
    },
  };
};
